namespace Gamification.Gamification {
    export interface UtentiProdottiEsperienzeDashboardRow {
        UserId?: number;
        TenantId?: number;
        IdUtenteProdottoEsperienzeDashboard?: number;
        IdUtenteProdotto?: number;
        IdProdottoEsperienza?: number;
        MigliorePunteggio?: number;
        PeggiorePunteggio?: number;
        UltimoPunteggio?: number;
        MigliorePunteggioData?: string;
        PeggiorePunteggioData?: string;
        UltimoPunteggioData?: string;
        MiglioreIdUtenteProdottoEsperienza?: number;
        PeggioreIdUtenteProdottoEsperienza?: number;
        UltimoIdUtenteProdottoEsperienza?: number;
        IdProdottoEsperienzaNome?: string;
    }

    export namespace UtentiProdottiEsperienzeDashboardRow {
        export const idProperty = 'IdUtenteProdottoEsperienzeDashboard';
        export const localTextPrefix = 'Gamification.UtentiProdottiEsperienzeDashboard';
        export const lookupKey = 'Gamification.UtentiProdottiEsperienzeDashboard';

        export function getLookup(): Q.Lookup<UtentiProdottiEsperienzeDashboardRow> {
            return Q.getLookup<UtentiProdottiEsperienzeDashboardRow>('Gamification.UtentiProdottiEsperienzeDashboard');
        }
        export const deletePermission = 'Gamification:Prodotti';
        export const insertPermission = 'Gamification:Prodotti';
        export const readPermission = 'Gamification:Prodotti';
        export const updatePermission = 'Gamification:Prodotti';

        export declare const enum Fields {
            UserId = "UserId",
            TenantId = "TenantId",
            IdUtenteProdottoEsperienzeDashboard = "IdUtenteProdottoEsperienzeDashboard",
            IdUtenteProdotto = "IdUtenteProdotto",
            IdProdottoEsperienza = "IdProdottoEsperienza",
            MigliorePunteggio = "MigliorePunteggio",
            PeggiorePunteggio = "PeggiorePunteggio",
            UltimoPunteggio = "UltimoPunteggio",
            MigliorePunteggioData = "MigliorePunteggioData",
            PeggiorePunteggioData = "PeggiorePunteggioData",
            UltimoPunteggioData = "UltimoPunteggioData",
            MiglioreIdUtenteProdottoEsperienza = "MiglioreIdUtenteProdottoEsperienza",
            PeggioreIdUtenteProdottoEsperienza = "PeggioreIdUtenteProdottoEsperienza",
            UltimoIdUtenteProdottoEsperienza = "UltimoIdUtenteProdottoEsperienza",
            IdProdottoEsperienzaNome = "IdProdottoEsperienzaNome"
        }
    }
}
